import { NavigateFunction } from 'react-router-dom';

import { handleExitOrEndWebinar } from '@src/utils';

import { IWebinarEvent } from '@src/types';

import { MEETING_ENDED } from '@src/constants';

export const handleEndSessionEvent = async (data: IWebinarEvent, navigate: NavigateFunction) => {
  const { body } = data;
  const reason = body?.reason;
  if ([MEETING_ENDED.MEETING_ENDED_BY_HOST].includes(reason)) {
    await handleExitOrEndWebinar({
      endSessionForAll: true,
      redirect: navigate,
      sendEvent: false,
    });
  }
};
